import clsx from 'clsx';
import { Bell } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useNotifications, useReadNotifications, useWorkspace } from '@/api';
import { formatWhen } from '@/lib/format';

export function NotificationBell() {
  const { data } = useNotifications();
  const read = useReadNotifications();
  const telegram = useWorkspace().data?.contour.channels.includes('telegram');
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const unread = data?.filter((n) => !n.read).length ?? 0;
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const close = (e: MouseEvent) => ref.current && !ref.current.contains(e.target as Node) && setOpen(false);
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button className="btn-ghost relative size-8 px-0" onClick={() => setOpen((o) => !o)} aria-label={unread ? `Уведомления, новых ${unread}` : 'Уведомления'} aria-expanded={open}>
        <Bell className="size-4" />
        {unread > 0 && <span className="absolute right-1.5 top-1.5 size-2 rounded-full bg-ink ring-2 ring-canvas" />}
      </button>
      {open && (
        <div className="absolute right-0 top-10 z-40 w-80 rounded-lg bg-canvas shadow-pop">
          <div className="flex items-center justify-between border-b border-line px-4 py-2.5">
            <span className="text-sm font-semibold">Уведомления</span>
            {unread > 0 && (
              <button className="text-xs text-muted hover:text-ink" onClick={() => read.mutate(undefined)}>
                Прочитать все
              </button>
            )}
          </div>
          {data && data.length === 0 && <p className="px-4 py-8 text-center text-sm text-muted">Пока ничего нового. Здесь появятся ответы команды, новые счета и всё, что ждёт вас.</p>}
          <ul className="max-h-96 divide-y divide-line overflow-y-auto">
            {data?.map((n) => (
              <li key={n.id}>
                <Link to={n.to} className="flex gap-3 px-4 py-3 hover:bg-panel">
                  <span className={clsx('mt-1.5 size-1.5 shrink-0 rounded-full', n.read ? 'bg-transparent' : 'bg-ink')} />
                  <span className="min-w-0 flex-1">
                    <span className={clsx('block text-sm leading-snug', !n.read && 'font-medium')}>{n.text}</span>
                    <span className="block text-xs text-muted">{formatWhen(n.at)}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/settings" className="block border-t border-line px-4 py-2.5 text-xs text-muted hover:text-ink">
            {telegram ? 'Настроить почту, Telegram и сводку' : 'Настроить почту и сводку'}
          </Link>
        </div>
      )}
    </div>
  );
}
